import React, { useRef, useState, useEffect } from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CardsContainer from './components/CardsContainer';
import AboutUs from './components/AboutUs';
import Training from './components/Training';
import Footer from './components/Footer';
//import CertSign from './components/CertSign';
import ContactUs from './components/ContactUs';
import AboutUsHomePage from './components/AboutUsHomePage';
import TrainingModule from './components/TrainingModule';
import PeerSupportCourse from './components/PeerSupportCourse';
import CollegeStudentCourse from './components/CollegeStudentCourse';
import FlightSchoolPeerSupportCourse from './components/FlightSchoolPeerSupportCourse';
import Courses from './components/Courses';
import MeetTheTeam from './components/MeetTheTeam';
import ScrollToTop from './components/ScrollToTop';
import ResetPassword from './components/ResetPassword';
import PrivacyPolicy from './components/PrivacyPolicy';
import TrainingForColleges from './components/TrainingForColleges';
import TrainingForAirlines from './components/TrainingForAirlines';
import TrainingForFlightSchools from './components/TrainingForFlightSchools';
import Wings from './components/Wings';
import { auth } from './components/firebase';
import { ADMIN_EMAILS } from './utils/wingsUtility';

// Admin-only route wrapper
const AdminRoute = ({ children }) => {
    const [loading, setLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            const email = user?.email || '';
            setIsAdmin(ADMIN_EMAILS.includes(email));
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <div className="container text-center py-5" style={{ paddingTop: '80px' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return isAdmin ? children : <Navigate to="/" replace />;
};

function App() {
    const mainContentRef = useRef(null);

    const handleSkipToMain = (e) => {
        e.preventDefault();
        if (mainContentRef.current) {
            mainContentRef.current.focus();
            mainContentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    return (
        <Router>
            <ScrollToTop />
            <div>
                {/* Skip to main content link for keyboard users */}
                <a 
                    href="#main-content" 
                    className="skip-link visually-hidden-focusable" 
                    style={{
                        position: 'absolute',
                        left: '-9999px',
                        zIndex: 9999,
                        padding: '10px 20px',
                        background: '#3768BD',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '4px',
                        fontWeight: 'bold'
                    }} 
                    onFocus={(e) => e.target.style.left = '10px'} 
                    onBlur={(e) => e.target.style.left = '-9999px'}
                    onClick={handleSkipToMain}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            handleSkipToMain(e);
                        }
                    }}
                >
                    Skip to main content
                </a>
                <Header />
                <main id="main-content" role="main" ref={mainContentRef} tabIndex={-1} style={{ outline: 'none' }}>
                    <Routes>
                    {/* Home Page */}
                    <Route 
                        path='/'
                        element={
                            <>
                                <Hero />
                                <CardsContainer />
                                <AboutUsHomePage/>
                            </>
                        }
                    />
                        {/* About Page */}
                        <Route path='/about' element={<AboutUs />} />
                        {/* Meet The Team Page */}
                        <Route path='/team' element={<MeetTheTeam />} />
                        {/* Contact Page */}
                        <Route path='/contact' element={<ContactUs />} />
                        {/* Training Page */}
                        <Route path='/training' element={<Training />} />
                        {/* Courses Selection Page */}
                        <Route path='/courses' element={<Courses />} />
                        {/* Wings Page - Admin only */}
                        <Route path='/wings' element={<AdminRoute><Wings /></AdminRoute>} />
                        {/* Free Pilot Course */}
                        <Route path='/course/free-pilot' element={<PeerSupportCourse />} />
                        {/* College Student Course */}
                        <Route path='/course/college-student' element={<CollegeStudentCourse />} />
                        {/* Flight School Course */}
                        <Route path='/course/flight-school' element={<FlightSchoolPeerSupportCourse />} />
                        {/* Training Module */}
                        <Route path='/tm' element={<TrainingModule />} />
                        {/* Password Reset */}
                        <Route path='/reset-password' element={<ResetPassword />} />
                        {/* Privacy Policy */}
                        <Route path='/privacy' element={<PrivacyPolicy />} />
                        {/* Training for Colleges */}
                        <Route path='/training-for-colleges' element={<TrainingForColleges />} />
                        {/* Training for Airlines */}
                        <Route path='/training-for-airlines' element={<TrainingForAirlines />} />
                        {/* Training for Flight Schools */}
                        <Route path='/training-for-flight-schools' element={<TrainingForFlightSchools />} />
                        {/* Catch-all route - Redirect any unknown paths to home page */}
                        <Route path='*' element={<Navigate to="/" replace />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;